module.exports = __webpack_public_path__ + "img/light.b2c0970a.jpg";